/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';

/**************************************** PROJECT MODULES *****************************************/
import {translate} from '@canimmunize/core-imports';

/********************************************* EXPORT *********************************************/
/**
 * Small onscreen loading message
 */
export const LoadMessage = () => {
    return (
        <div className={cn(`p-15 fs-20`)}>
            {translate('loading').capitalize}
            ...
        </div>
    );
};

LoadMessage.displayName = `LoadMessage`;
